import { memo, useRef } from 'react';
import { LottieContainer } from '@/sub-luca-plugin/compatible-components';
import { ISolveStatus } from '@/sub-luca-plugin/types/models/qa';
import { getQaStore } from '@/sub-luca-plugin/store/qa';
import classNames from 'classnames';
import './index.scss';

interface IProps {
    title?: string;
    state?: ISolveStatus;
    onSolve?: (state: ISolveStatus) => Promise<any>;
}

const WhetherSolve = ({ title, state, onSolve }: IProps) => {
    const hasChoosed = useRef(false);
    const handleSolve = async (state: ISolveStatus) => {
        if (hasChoosed.current) return;
        hasChoosed.current = true;
        const { setLockStatus, clearLockStatus } = getQaStore()!;
        setLockStatus('replying');
        try {
            await onSolve?.(state);
        } catch (error) {
            hasChoosed.current = false;
        }
        clearLockStatus('replying');
    };

    return (
        <>
            <div className="whether-solve">
                <div className={classNames('whether-solve__title', state && [2, 3].includes(state) && 'whether-solve__title--finised')}>
                    {title || '到目前为止，是否解决了你的问题'}
                </div>
                <div className="whether-solve__operations">
                    {state !== 2 && (
                        <div
                            className={classNames('whether-solve__unsolve', state === 3 && 'whether-solve__unsolved')}
                            onClick={() => handleSolve(3)}
                        >
                            {state === 3 ? (
                                <LottieContainer className="whether-solve__icon" type="unresolved" excuteType="autoPlayByInit" />
                            ) : (
                                <div className="whether-solve__icon"></div>
                            )}
                            <span>未解决</span>
                        </div>
                    )}
                    {state !== 3 && (
                        <div
                            className={classNames('whether-solve__solve', state === 2 && 'whether-solve__solved')}
                            onClick={() => handleSolve(2)}
                        >
                            {state === 2 ? (
                                <LottieContainer className="whether-solve__icon" type="resolved" excuteType="autoPlayByInit" />
                            ) : (
                                <div className="whether-solve__icon"></div>
                            )}
                            <span>已解决</span>
                        </div>
                    )}
                </div>
            </div>
            {state === 2 && <div className="whether-solve__solved-tips">{`很高兴能够帮助到你\n如果你还有其他问题，随时向我提问！`}</div>}
        </>
    );
};

export default memo(WhetherSolve);
